/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useLocation, useNavigate } from "react-router-dom";
import {
  API,
  defaultLimitPagination,
  fileUpload,
  get,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import Pagination from "../../components/Pagination";
import { formatContactName } from "../../lib/Misc";
import MainBody from "../../components/MainBody/MainBody";
import { CalendarDatePicker } from "../../components/CalendarDatePicker";
import { AnimatedTooltip } from "../../components/AnimatedTooltip";
import { Button } from "../../components/ui/button";
import { Download } from "lucide-react";
import moment from "moment";
import CustomTooltip from "../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUndo } from "@fortawesome/free-solid-svg-icons";
import Confirmation from "../../components/Confirmation";
import UnauthorisedAccess from "../../UnauthorisedAccess";
import { useOrganization } from "../../lib/context/OrganisationContext";
// Here id => VenderId
const ReconciledItems = ({
  selectedDateRange,
  setSelectedDateRange,
  trustId,
  isDesktop,
  readAccess,
  writeAccess,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const [loading, setLoading] = useState(false);
  const [reconcileItemList, setReconcileItemList] = useState([]);
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const { organizationData } = useOrganization();

  const [showUndo, setShowUndo] = useState(false);
  const [itemId, setItemId] = useState();
  const [isUsedInPayment, setIsUsedInPayment] = useState();

  const toggleUndoModal = () => {
    setShowUndo(!showUndo);
  };

  var today = new Date();
  today.setHours(0, 0, 0, 0);

  // *API Call for Geting Assets - Start

  const fetchReconcileItem = useCallback(
    async (passLimit, passPage) => {
      try {
        setLoading(true);

        const { data } = await get(
          `${API.BANK_RECONCILIATION_LIST}?trust_id=${trustId}&limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}&start_date=${
            moment(selectedDateRange?.from).format("DD-MM-YYYY")
              ? moment(selectedDateRange?.from).format("DD-MM-YYYY")
              : ""
          }&end_date=${
            moment(selectedDateRange?.to).format("DD-MM-YYYY")
              ? moment(selectedDateRange?.to).format("DD-MM-YYYY")
              : ""
          }&processed=1`
        );

        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        setReconcileItemList(data?.data?.data);

        setLoading(false);
      } catch (error) {
        setLoading(false);
        setReconcileItemList([]);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedDateRange?.from, selectedDateRange?.to, trustId]
  );

  // *API Call for Geting Assets - End

  const reconcileItemGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      for (
        let j = 0;
        j < reconcileItemList[i].bank_reconciliation.length;
        j++
      ) {
        items.push({
          key: reconcileItemList[i]?.bank_reconciliation[j].id,
          contact: formatContactName(
            reconcileItemList[i]?.bank_reconciliation[j]?.contactable_type,
            reconcileItemList[i]?.bank_reconciliation[j]?.contactable,
            organizationData?.organizationData
          ),
          date: reconcileItemList[i]?.transaction_date
            ? moment(
                reconcileItemList[i]?.transaction_date,
                "DD-MM-YYYY"
              ).format("DD-MM-YYYY")
            : "-",
          description: reconcileItemList[i]?.bank_reconciliation[j]?.description
            ? reconcileItemList[i]?.bank_reconciliation[j]?.description
            : "",
          credit:
            reconcileItemList[i]?.base_type === 1 ? (
              <span className="rag-green">
                $
                {reconcileItemList[i]?.bank_reconciliation[
                  j
                ]?.amount?.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            ) : (
              "-"
            ),
          debit:
            reconcileItemList[i]?.base_type === 0 ? (
              <span className="rag-red">
                $
                {reconcileItemList[i]?.bank_reconciliation[
                  j
                ]?.amount?.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            ) : (
              "-"
            ),
          balance: reconcileItemList[i]?.balance
            ? reconcileItemList[i]?.balance
            : "-",
          bank_transaction_source: reconcileItemList[i]?.source
            ? reconcileItemList[i]?.source
            : "-",
          chart_of_account: reconcileItemList[i]?.bank_reconciliation[j]
            ?.chart_of_account?.name
            ? reconcileItemList[i]?.bank_reconciliation[j]?.chart_of_account
                ?.name
            : "-",
          action: (
            <span className="flex items-center gap-2 justify-center">
              <CustomTooltip message={"Undo"}>
                <span>
                  <FontAwesomeIcon
                    onClick={() => {
                      setItemId(reconcileItemList[i]?.id);
                      setIsUsedInPayment(
                        reconcileItemList[i]?.bank_reconciliation[j]?.is_payments ? true : false
                      );
                      toggleUndoModal();
                    }}
                    icon={faUndo}
                    size="1x"
                    data-toggle="modal"
                    data-target="#clientDetail"
                  />
                </span>
              </CustomTooltip>
            </span>
          ),
        });
      }
    }
    return items;
  };

  const reconcileItem = reconcileItemGenerator(reconcileItemList?.length);

  const columns = [
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "date",
      text: "Date",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "description",
      text: "Description",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "credit",
      text: "Credit",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "debit",
      text: "Debit",
    },

    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "bank_transaction_source",
      text: "Bank Transaction Source",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "contact",
      text: "Subcontractor/Beneficiary",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "action",
      text: "Action",
      align: "center",
      headerAlign: "center",
      style: { width: "127px" },
    },
  ];

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC"
      );
    }
  };

  useEffect(() => {
    fetchReconcileItem();
  }, [fetchReconcileItem]);

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchReconcileItem(limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchReconcileItem(limit, page);
  };
  // *Assets Table Row and Column Generation, Filtering and Sorting of Record - End

  useEffect(() => {
    navigate(
      `?tab=reconcile-item&limit=${
        limit ? limit : defaultLimitPagination
      }&page=${page ? page : 1}&sort_column=${
        sortField ? sortField : ""
      }&sort_order=${sortOrder ? sortOrder : ""}&from=${
        moment(selectedDateRange?.from).format("DD-MM-YYYY")
          ? moment(selectedDateRange?.from).format("DD-MM-YYYY")
          : ""
      }&to=${
        moment(selectedDateRange?.to).format("DD-MM-YYYY")
          ? moment(selectedDateRange?.to).format("DD-MM-YYYY")
          : ""
      }`,
      {
        replace: true,
      }
    );
  }, [
    navigate,
    limit,
    page,
    sortField,
    sortOrder,
    selectedDateRange?.from,
    selectedDateRange?.to,
  ]);

  const handleExport = async (format) => {
    try {
      setLoading(true);
      const { data } = await get(
        `${API.BANK_RECONCILIATION_LIST}?trust_id=${trustId}&start_date=${
          moment(selectedDateRange?.from).format("DD-MM-YYYY")
            ? moment(selectedDateRange?.from).format("DD-MM-YYYY")
            : ""
        }&end_date=${
          moment(selectedDateRange?.to).format("DD-MM-YYYY")
            ? moment(selectedDateRange?.to).format("DD-MM-YYYY")
            : ""
        }&export=1&processed=1&format=${format}`
      );
      const export_report_path = data?.data?.file;
      if (export_report_path) {
        var a = document.createElement("a");
        a.href = export_report_path;
        var file = export_report_path.split("/");
        a.setAttribute(
          "download",
          file[file.length - 1] || "bank_reconciled_report.pdf"
        );
        a.setAttribute("target", "_blank");
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();
        setLoading(false);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const handleReconcileItemUndo = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("trust_id", trustId);
      formData.append("status", "0");
      formData.append("_method", "put");

      await fileUpload(`${API.UPDATE_BANK_RECONCILIATION}/${itemId}`, formData);

      fetchReconcileItem(limit, page);
      toggleUndoModal();
      setItemId();
      setIsUsedInPayment(false);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return readAccess ? (
    <>
      <div className="relative">
        <MainBody
          search={false}
          innerBody={true}
          actionAlign={"end"}
          parentHeight={true}
          actionContent={
            <>
              {" "}
              <div className="flex items-center gap-2">
                <CalendarDatePicker
                  date={selectedDateRange}
                  onDateSelect={setSelectedDateRange}
                  variant="outline"
                  align={isDesktop ? "end" : "start"}
                  disabledDate={(date) => date > new Date()}
                />
                <AnimatedTooltip title={"Export"}>
                  <Button
                    onClick={() => handleExport("pdf")}
                    className="flex gap-2 items-center"
                  >
                    Export <Download size={18} />
                  </Button>
                </AnimatedTooltip>
              </div>
            </>
          }
          loading={loading}
        >
          <div className="custom-table">
            <div className={"table-body-class sm:max-h-[643px]"}>
              <BootstrapTable
                keyField="asset_id"
                remote
                data={reconcileItem}
                columns={columns}
                onTableChange={handleTableChange}
                rowClasses={TRClasses}
                noDataIndication="No Data Found"
                classes={TableClasses}
                wrapperClasses={TableWrapClasses}
              />
            </div>

            <Pagination
              total={total}
              limit={parseInt(limit)}
              currentPage={page}
              updateLimit={handleUpdateLimit}
              updatePage={handleChangePage}
              from={from}
              to={to}
            />
            {showUndo && (
              <Confirmation
                title={"Undo Reconciled Item"}
                open={showUndo}
                setOpen={setShowUndo}
                toggleShow={() => {
                  toggleUndoModal();
                }}
                popupType={"bank-reconciliations"}
                className="sm:max-w-fit"
                message={
                  <div>
                    <p>Are your sure you want to undo this reconciled item?</p>
                    <p>
                      {isUsedInPayment ? (
                        <>
                          <span className="font-bold text-webPrimary">Note:{" "}</span>Reconciled
                          bank transaction cannot be restored because the
                          receipt is already used in the payments.
                        </>
                      ) : ""}
                    </p>
                  </div>
                }
                okAction={async () => {
                  await handleReconcileItemUndo();
                }}
                loading={loading}
                cancelAction={() => {
                  toggleUndoModal();
                }}
              />
            )}
          </div>
        </MainBody>
      </div>
    </>
  ) : (
    <UnauthorisedAccess expandList={true} popup={true} />
  );
};
export default ReconciledItems;
